export default class AjaxError {
  init() {
    $(document).ajaxError((event, request) => {
      const defaultMessageContainer = $('#ajax_error .default_message');
      const detailsContainer = $('#ajax_error .details');

      defaultMessageContainer.hide();
      detailsContainer.hide();

      if (request.status === 422 && this.hasFilledErrors(request)) {
        detailsContainer.html(this.formatResponseErrors(request));
        detailsContainer.show();
      } else if (request.status !== 400) {
        defaultMessageContainer.show();
      }

      $('#ajax_error').show();
    });
  }

  hasFilledErrors(request) {
    return request.responseJSON.error || request.responseJSON.errors;
  }

  formatResponseErrors(request) {
    let resultErrors = [];

    const error = request.responseJSON.error;
    if (error) resultErrors = resultErrors.concat(error);

    const errors = request.responseJSON.errors;
    if (errors) resultErrors.concat(errors);

    return resultErrors.join('<br>');
  }
}
